import { render, staticRenderFns } from "./edit_cnab_remittance.vue?vue&type=template&id=2b05d944&scoped=true"
import script from "./edit_cnab_remittance.vue?vue&type=script&lang=js"
export * from "./edit_cnab_remittance.vue?vue&type=script&lang=js"
import style0 from "./edit_cnab_remittance.vue?vue&type=style&index=0&id=2b05d944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b05d944",
  null
  
)

export default component.exports